import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import { rem } from '@mantine/styles';
import { SelectScrollArea } from '../SelectScrollArea/SelectScrollArea.js';
import useStyles from './SelectPopover.styles.js';
import { Popover } from '../../Popover/Popover.js';
import { Box } from '../../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function SelectPopoverDropdown(_a) {
  var _b = _a,
      children = _b.children,
      _b$component = _b.component,
      component = _b$component === void 0 ? "div" : _b$component,
      _b$maxHeight = _b.maxHeight,
      maxHeight = _b$maxHeight === void 0 ? 220 : _b$maxHeight,
      _b$direction = _b.direction,
      direction = _b$direction === void 0 ? "column" : _b$direction,
      id = _b.id,
      innerRef = _b.innerRef,
      __staticSelector = _b.__staticSelector,
      styles = _b.styles,
      classNames = _b.classNames,
      unstyled = _b.unstyled,
      others = __objRest(_b, ["children", "component", "maxHeight", "direction", "id", "innerRef", "__staticSelector", "styles", "classNames", "unstyled"]);

  var _useStyles = useStyles(null, {
    name: __staticSelector,
    styles,
    classNames,
    unstyled
  }),
      classes = _useStyles.classes;

  return /* @__PURE__ */React.createElement(Popover.Dropdown, __spreadValues({
    p: 0,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, others), /* @__PURE__ */React.createElement("div", {
    style: {
      maxHeight: rem(maxHeight),
      display: "flex"
    }
  }, /* @__PURE__ */React.createElement(Box, {
    component: component || "div",
    id: "".concat(id, "-items"),
    "aria-labelledby": "".concat(id, "-label"),
    role: "listbox",
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    },
    style: {
      flex: 1,
      overflowY: component !== SelectScrollArea ? "auto" : void 0
    },
    "data-combobox-popover": true,
    tabIndex: -1,
    ref: innerRef
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.itemsWrapper,
    style: {
      flexDirection: direction
    }
  }, children))));
}

function SelectPopover(_ref) {
  var opened = _ref.opened,
      _ref$transitionProps = _ref.transitionProps,
      transitionProps = _ref$transitionProps === void 0 ? {
    transition: "fade",
    duration: 0
  } : _ref$transitionProps,
      shadow = _ref.shadow,
      withinPortal = _ref.withinPortal,
      portalProps = _ref.portalProps,
      children = _ref.children,
      __staticSelector = _ref.__staticSelector,
      onDirectionChange = _ref.onDirectionChange,
      switchDirectionOnFlip = _ref.switchDirectionOnFlip,
      zIndex = _ref.zIndex,
      dropdownPosition = _ref.dropdownPosition,
      _ref$positionDependen = _ref.positionDependencies,
      positionDependencies = _ref$positionDependen === void 0 ? [] : _ref$positionDependen,
      classNames = _ref.classNames,
      styles = _ref.styles,
      unstyled = _ref.unstyled,
      readOnly = _ref.readOnly,
      variant = _ref.variant;
  return /* @__PURE__ */React.createElement(Popover, {
    unstyled,
    classNames,
    styles,
    width: "target",
    withRoles: false,
    opened,
    middlewares: {
      flip: dropdownPosition === "flip",
      shift: false
    },
    position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
    positionDependencies,
    zIndex,
    __staticSelector,
    withinPortal,
    portalProps,
    transitionProps,
    shadow,
    disabled: readOnly,
    onPositionChange: function onPositionChange(nextPosition) {
      return switchDirectionOnFlip && (onDirectionChange == null ? void 0 : onDirectionChange(nextPosition === "top" ? "column-reverse" : "column"));
    },
    variant
  }, children);
}

SelectPopover.Target = Popover.Target;
SelectPopover.Dropdown = SelectPopoverDropdown;
export { SelectPopover };